//our store
import {createStore,
    applyMiddleware} from "redux";
//for making asynchonous http requests
import thunk from "redux-thunk";
import mainreducer from '../reductors/mainreducer';
const middleware=applyMiddleware(thunk);
export default createStore(mainreducer,middleware); 
